import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAdminUser } from '@/lib/role-guards'
import { AdminReportsPage } from '@/features/admin/reports'

export const Route = createFileRoute('/_authenticated/admin/reports')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AdminReportsPage,
})
